import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledSection = styled.section`
  padding-top: ${tokens.spacing.section};
  padding-bottom: ${tokens.spacing.section};
  background-color: ${({ $alt }) => ($alt ? tokens.colors.backgroundAlt : tokens.colors.background)};
`;

export function Section({ alt, children, ...props }) {
  return (
    <StyledSection $alt={alt} {...props}>
      {children}
    </StyledSection>
  );
}

export default Section;
